/**
 * The chat header's title: the conversation being shown, so the header says
 * WHAT you are looking at rather than repeating the panel's "Conversations"
 * heading beside it (2026-10-17 review of the double-menu fix).
 *
 * - No active conversation (a fresh, unsaved chat): "New conversation".
 * - Active: that conversation's title from the already-loaded list (the same
 *   cached query the panel renders, so no extra request), or "Untitled" — the
 *   same fallback a nameless row shows in the panel.
 */
import { useConversations } from '@/features/chat/data-access/useConversations';
import { useSessionStore } from '@/features/chat/store/sessionStore';

export function ChatHeaderTitle() {
  const activeConversationId = useSessionStore((s) => s.activeConversationId);
  const { data: conversations } = useConversations();

  const title =
    activeConversationId == null
      ? 'New conversation'
      : (conversations ?? []).find((c) => c.id === activeConversationId)
          ?.title || 'Untitled';

  return (
    <h1
      className="min-w-0 truncate font-sans font-semibold text-content-primary text-sm"
      // data-testid="chat-title" — the current conversation's title.
      data-testid="chat-title"
    >
      {title}
    </h1>
  );
}
